// Mirrors the output of trpc.stock.list (apps/web/src/api/trpc/routers/stock.ts).

export type BaseUnit = "piece" | "ml" | "g";

export type StockUnit = { id?: number; name: string; base_qty: number };

export type StockItem = {
  id: number;
  guid: string;
  name: string;
  base_unit: BaseUnit;
  stock_category: string | null;
  avg_cost: number;
  last_cost: number | null;
  par_level: number | null;
  allergens: string[];
  active: boolean;
  qty_on_hand: number;
  units: (StockUnit & { id: number })[];
};

export const BASE_UNITS: BaseUnit[] = ["piece", "ml", "g"];
